<app-timeout></app-timeout>
<div class="container-fluid app-content-view">
  @if (isUserAuthorized && (readOnlyAccessData || readWriteAccessData)) {
    <div class="AuthCheck">
      <div class="opm-search-container">
        <form>
          <table class="search-grid" [ngStyle]="{'width':(isnotduplicatesync)? '100%':'50%'}">
            <tbody>
              <tr>
                @if (isnotduplicatesync) {
                  <td class="field">GUID From PDI (EMPGUID)</td>
                }
                <td class="field">Email Address</td>
                @if (isnotduplicatesync) {
                  <td class="field">Person Id (EmpCode)</td>
                }
                @if (isnotduplicatesync) {
                  <td class="field">Name</td>
                }
                @if (isnotduplicatesync) {
                  <td class="field">Alias</td>
                }
                <td class="field"></td>
                @if (isnotduplicatesync) {
                  <td class="field"></td>
                }
                @if (isnotduplicatesync) {
                  <td class="field"></td>
                }
                @if (isnotduplicatesync) {
                  <td class="field"></td>
                }
              </tr>
              <tr>
                @if (isnotduplicatesync) {
                  <td class="value">
                    <input name="GlobalPersonId" type="text" maxlength="10" (keypress)="numberOnly($event)"
                      class="input-sm" [(ngModel)]="filter.GlobalPersonId" />
                    </td>
                  }
                  <td class="value">
                    <input name="EmailAddress" class="input-lg" maxlength="50" [(ngModel)]="filter.Email" />
                  </td>
                  @if (isnotduplicatesync) {
                    <td class="value">
                      <input name="PersonId" class="input-sm" maxlength="20" [(ngModel)]="filter.PersonId" />
                    </td>
                  }
                  @if (isnotduplicatesync) {
                    <td class="value"><input name="FullName" class="input-lg" maxlength="50" [(ngModel)]="filter.Name" /></td>
                  }
                  @if (isnotduplicatesync) {
                    <td class="value">
                      <input name="Alias" class="input-sm" maxlength="25" [(ngModel)]="filter.EmployeeAlias" />
                    </td>
                  }
                  @if (isnotduplicatesync) {
                    <td class="value separator">
                      <button class="search-button" (click)="search()"
                        [disabled]="!isFormValid()">
                        Search
                      </button>
                    </td>
                  }
                  @if (!isnotduplicatesync) {
                    <td class="value separator">
                      <button class="search-button" (click)="searchDuplicate()"
                        [disabled]="!isFormValid()" style="float:left">
                        Search
                      </button>
                      <button class="search-button" (click)="syncAll()"
                        style="float:left">
                        Show All Duplicates
                      </button>
                    </td>
                  }
                  @if (isnotduplicatesync && readWriteAccessData) {
                    <td class="value"><button class="show-button" (click)="showModified()">Show All Modified</button></td>
                  }
                  @if (isnotduplicatesync && readWriteAccessData) {
                    <td class="value export-modified"><button (click)="exportModified()">Export All Modified</button></td>
                  }
                  @if (isnotduplicatesync) {
                    <td class="value export-modified"><button (click)="syncAll()">Duplicate Sync</button></td>
                  }
                  @if (isshowprofile && isnotduplicatesync && readWriteAccessData) {
                    <td class="value add-profile">
                      <button [routerLink]="['/createProfile',users.GlobalPersonUid]" [skipLocationChange]="true" (click)="TraceLog()">
                        ADD PROFILE
                      </button>
                    </td>
                  }
                </tr>
              </tbody>
            </table>
          </form>
        </div>
        @if (!!gridDataModel && !visiblNoMatchesFoundPopup) {
          <div class="search-results-container">
            @if (isPagingVisible) {
              <opm-paging [totalRecords]="totalCount" [currentPage]="currentPage"
                (pageChanged)="onPageChange($event)">
              </opm-paging>
            }
            <!-- <ng-template *ngIf="gridResult == gridResultEnum.Modified; then modified ; else  search">
          </ng-template> -->
          @switch (gridResult) {
            @case (gridResultEnum.Search) {
              <ng-container #search>
                <opm-grid [metaName]="gridTypeEnum.Main" [users]="gridDataModel.GlobalEmployeeDetails"></opm-grid>
              </ng-container>
            }
            @case (gridResultEnum.Modified) {
              <ng-container #modified>
                <opm-grid [metaName]="gridTypeEnum.Main" [users]="gridDataModel.GlobalEmployeeDetails"></opm-grid>
              </ng-container>
            }
            @case (gridResultEnum.Sync) {
              <ng-container #sync>
                <opm-grid [metaName]="gridTypeEnum.Sync" [users]="gridDataModel.GlobalEmployeeDetails" (userSyncAction)="populateUsersData($event)"></opm-grid>
              </ng-container>
            }
          }
          @if (isPagingVisible) {
            <opm-paging [totalRecords]="totalCount" [currentPage]="currentPage"
              (pageChanged)="onPageChange($event)">
            </opm-paging>
          }
        </div>
      }
      @if (visiblNoMatchesFoundPopup) {
        <opm-modal-popup header="Search" [cancelVisibility]="false"
          message="{{noMatchesFoundMsg}}" okButtonName="Ok" (onOk)="gridDataModel = null; visiblNoMatchesFoundPopup = false">
        </opm-modal-popup>
      }
    </div>
  }
  @if (!isUserAuthorized ||( !readWriteAccessData && !readOnlyAccessData) ) {
    <div class="user-unauthorized">{{errorMessage}}</div>
  }
</div>
<opm-footer></opm-footer>
